import { useMemo } from 'react'
import { useAppSelector } from '../redux/hook' // adjust path if needed

interface UseUserDateFormatReturn {
    hasMeridiem: boolean
    userPreferredDateFormat: string
    dateFormat?: string
    timeFormat?: string
}

export const useUserDateFormat = (): UseUserDateFormatReturn => {
    const userLocalization = useAppSelector(
        (state) => state.user.user?.preferences?.localization,
    )

    const result = useMemo(() => {
        const dateFormat = userLocalization?.dateFormat
        const timeFormat = userLocalization?.timeFormat

        const hasMeridiem = timeFormat?.startsWith('hh:mm') ?? false

        let userPreferredDateFormat = 'MM/DD/YYYY HH:mm'

        if (dateFormat && timeFormat) {
            const formattedTime = timeFormat.split(':').slice(0, 2).join(':')

            const meridiem = timeFormat.includes('A') ? 'A' : ''

            userPreferredDateFormat =
                `${dateFormat} ${formattedTime} ${meridiem}`.trim()
        }

        return {
            hasMeridiem,
            userPreferredDateFormat,
            dateFormat,
            timeFormat,
        }
    }, [userLocalization])

    return result
}
